import { OperationsPlusIcon } from '@tableau/icons/OperationsPlusIcon';
import { ButtonType, ButtonWidget, TabStyles } from '@tableau/widgets';
import React from 'react';

import { openReactActionDialog } from '~commonInfra/dialogs/ReactActionDialog';
import { TabDialogWidth } from '~commonInfra/dialogs/style/TabDialogWidth';
import { ToasterService, ToastType } from '~commonInfra/services/ToasterService';
import { Messages } from '~src/codegen/Localize';
import { AddDataConnectPoolDialogBody, AddDataConnectPoolDialogProps, AddDataConnectPoolDialogState } from '~src/settings/dataconnect-settings/sections/dataConnectMultiPool/AddDataConnectPoolDialog';
import { ICreateBaasEdgePoolResult } from '~src/settings/dataconnect-settings/serverApi/requests/CreateBaasEdgePoolRequest';
import { BaasEdgePoolAndCluster } from '~src/settings/dataconnect-settings/serverApi/resources/BaasEdgePoolAndCluster';
import { cssClass } from '~src/style';

import { getGeneralErrorMessage } from '../utils/EdgePoolErrorUtilities';


const addPoolButtonClass = cssClass('add-pool', 'root', {
  display: 'block',
  marginBottom: TabStyles.Spacing.DefaultSpace
});

const addPoolIconClass = cssClass('add-pool', 'icon', {
  verticalAlign: 'middle'
});

export type AddNewPoolButtonProps = Readonly<{
  existingPoolNames: ReadonlyArray<string>;
  siteId: string;
  refreshEdgePools: () => void;
  hasLoadedEdgePools: boolean;
}>;

export function AddNewPoolButton(props: AddNewPoolButtonProps) {
  return (
    <ButtonWidget
      title={Messages.dataConnectSiteSettingsAddPool()}
      buttonType={ButtonType.Outline}
      testId={'add-new-pool-button'}
      onClick={() => openAddNewPoolDialog(props.existingPoolNames, props.siteId, props.refreshEdgePools)}
      className={addPoolButtonClass}
      disabled={!props.hasLoadedEdgePools}
    >
      <OperationsPlusIcon size={14} className={addPoolIconClass} role={'presentation'} />
      <span> {Messages.dataConnectSiteSettingsAddPool()} </span>
    </ButtonWidget>
  );
}

function openAddNewPoolDialog(existingPoolNames: ReadonlyArray<string>, siteId: string, refreshEdgePools: () => void) {
  const action = (_: AddDataConnectPoolDialogProps, state: AddDataConnectPoolDialogState) => {
   return  BaasEdgePoolAndCluster.createBaasPool({ displayName: state.poolName, DataConnectSettingsVersion: '0' })
      .then((result: ICreateBaasEdgePoolResult) => {
        refreshEdgePools();
        if (result.errors) {
          ToasterService.instance.pop({
            type: ToastType.Error,
            text: getGeneralErrorMessage(result.errors[0].code, result.errors[0].message)
          });
        }
        if (result.success) {
          ToasterService.instance.pop({ type: ToastType.Success, text: Messages.dataConnectSiteSettingsAddPoolSuccess({ POOL_NAME: state.poolName }) });
        }
        return Promise.resolve();
      });
  };

  const dialogInstance = openReactActionDialog({
    title: Messages.dataConnectSiteSettingsAddPool(),
    bodyComponent: AddDataConnectPoolDialogBody,
    initialBodyProps: { existingPoolNames },
    initialDialogState: { poolName: '', hasError: false },
    actionName: Messages.dataConnectSiteSettingsAddPoolButton(),
    action: action,
    actionDisabled: (_, state: AddDataConnectPoolDialogState) => state.poolName.length === 0 || state.hasError,
    dismissDialogOnActionFailed: false,
    dialogWidth: TabDialogWidth.width375px,
  });

  return Promise.resolve(dialogInstance.result);
}
